/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PhrAuthTokenTypename = "PhrAuthToken" as const;

/**
 *
 * @export
 * @interface PhrAuthToken
 */
export interface PhrAuthToken {
  /**
   *
   * @type {string}
   * @memberof PhrAuthToken
   */
  token?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrAuthToken
   */
  readonly __typename?: string;
}

export function PhrAuthTokenFromJSON(json: any): PhrAuthToken {
  return PhrAuthTokenFromJSONTyped(json, false);
}

export function PhrAuthTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrAuthToken {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrAuthTokenTypename,

    token: !exists(json, "token") ? undefined : json["token"],
  };
}

export function PhrAuthTokenToJSON(object?: PhrAuthToken | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    token: value.token,
  };
}
